module.exports = __webpack_public_path__ + "static/rcc-ar-table-mobile-bc00173d2693728f167a85fd2fb05bd2.png";